module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kanto-3-7bfe6b667fe22e01eff27ea8519fc5c3.png";